import React from 'react';
import styles from './expert-card.module.css';

interface ExpertCardProps {
  image: string;
  name: string;
  role: string;
  description?: string;
  isVerified?: boolean;
  socials?: {
    instagram?: string;
    substack?: string;
    website?: string;
    youtube?: string;
    applePodcasts?: string;
  };
}

export const ExpertCard: React.FC<ExpertCardProps> = ({
  image,
  name,
  role,
  description,
  isVerified = true,
  socials = {
    instagram: "https://instagram.com",
    substack: "https://substack.com",
    website: "https://example.com"
  } // Default placeholders
}) => {
  return (
    <div className={styles.card}>
      <img src={image} alt={name} className={styles.image} />

      <div className={styles.overlay}>
        <div className={styles.header}>
          <h3 className={styles.name}>{name}</h3>
          {isVerified && (
            <div className={styles.verifiedBadge}>
              <span className="material-icons" style={{ fontSize: '18px' }}>verified</span>
            </div>
          )}
        </div>

        <div className={styles.role}>{role}</div>

        {description && (
          <p className={styles.description}>{description}</p>
        )}

        <div className={styles.socials}>
          {socials?.instagram && (
            <a href={socials.instagram} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Instagram">
              <img src="/assets/logos/instagram.svg" alt="Instagram" className={styles.socialIcon} />
            </a>
          )}
          {socials?.youtube && (
            <a href={socials.youtube} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="YouTube">
              <img src="/assets/logos/youtube.svg" alt="YouTube" className={styles.socialIcon} />
            </a>
          )}
          {socials?.applePodcasts && (
            <a href={socials.applePodcasts} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Apple Podcasts">
              <img src="/assets/logos/applepodcasts.svg" alt="Apple Podcasts" className={styles.socialIcon} />
            </a>
          )}
          {socials?.substack && (
            <a href={socials.substack} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Substack">
              <img src="/assets/logos/substack.svg" alt="Substack" className={styles.socialIcon} />
            </a>
          )}
          {socials?.website && (
            <a href={socials.website} target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Website">
              <span className={`material-icons ${styles.materialIcons}`}>language</span> {/* Globe for Website */}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
